import React, { useEffect, useState } from "react";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode";
import { useFlowStore } from "../../store/FlowStateStore.ts";

const RequestInterventation: React.FC<any> = ({ nodeId, subNodeId, nodeContent }) => {
  const { nodes, setNodes } = useFlowStore();

  const [waitMessage, setWaitMessage] = useState<string>("");
  const [reason, setReason] = useState<string>("");

  // Initialize from saved node content
  useEffect(() => {
    if (nodeContent?.data) {
      setWaitMessage(nodeContent.data.waitMessage ?? "");
      setReason(nodeContent.data.reason ?? "");
    }
  }, []);

  const persist = (field: string, value: string) => {
    const updated = nodes.map((node) => {
      if (node.data.id !== nodeId) return node;
      return {
        ...node,
        data: {
          ...node.data,
          content: (node.data as CanvasNodeData).content.map((c) => {
            if (c.id !== subNodeId) return c;
            return {
              ...c,
              data: {
                ...(c.data ?? {}),
                [field]: value,
              },
            };
          }),
        },
      };
    });
    setNodes([...(updated as CanvasNode[])]);
  };

  const handleWaitMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWaitMessage(e.target.value);
    persist("waitMessage", e.target.value);
  };

  const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReason(e.target.value);
    persist("reason", e.target.value);
  };

  return (
    <div className="node-body">
      {/* Header badge */}
      <div
        className="flex flex-row items-center"
        style={{ backgroundColor: "white", borderRadius: "5px", padding: "5px", marginBottom: "8px" }}
      >
        {/* <img
          src={require("../../assets/sidepanel/interventation.png")}
          style={{ height: "20px", width: "20px" }}
          alt="intervention"
        /> */}
        <div style={{ marginLeft: "8px" }}>
          <div className="font-label" style={{ fontWeight: 600 }}>Request Intervention</div>
          <div className="font-label" style={{ fontSize: "11px", color: "#888" }}>Hand off to a human agent</div>
        </div>
      </div>

      {/* Wait message sent to customer */}
      <div style={{ marginBottom: "8px" }}>
        <div className="font-label" style={{ marginBottom: "4px" }}>
          Message to customer <span style={{ color: "#999", fontWeight: 400 }}>(optional)</span>
        </div>
        <input
          type="text"
          className="node-input"
          placeholder="e.g. Please wait, connecting you to an agent…"
          value={waitMessage}
          onChange={handleWaitMessageChange}
          style={{ width: "100%", fontSize: "12px" }}
        />
      </div>

      {/* Internal reason tag for the agent dashboard */}
      <div>
        <div className="font-label" style={{ marginBottom: "4px" }}>
          Reason tag <span style={{ color: "#999", fontWeight: 400 }}>(visible to agents)</span>
        </div>
        <input
          type="text"
          className="node-input"
          placeholder="e.g. billing_support"
          value={reason}
          onChange={handleReasonChange}
          style={{ width: "100%", fontSize: "12px" }}
        />
      </div>
    </div>
  );
};

export default RequestInterventation;
